'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var onError = function onError(containerId) {
  console.log('==> can not load container ' + containerId);
};
var scriptGtm = function scriptGtm(w, d, s, l, i) {
  w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],

  // eslint-disable-next-line
  j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.onerror = function () {
    return onError(i);
  };
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  j.addEventListener("load", function () {
    var _ge = new CustomEvent("gtm_loaded", { bubbles: true });d.dispatchEvent(_ge);
  });
  f.parentNode.insertBefore(j, f);
};

exports.default = function (containerId) {
  try {
    scriptGtm(window, document, 'script', 'dataLayer', containerId);
  } catch (e) {
    console.log('==> can not add script GTM container');
    console.log(e);
  }
};